"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_get_symbol_1 = require("@hopin-team/ui-helper-get-symbol");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importStar(require("styled-components")); // Color =======================================================================


var makeColorStyles = function makeColorStyles(background, theme) {
  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), (0, ui_helper_get_symbol_1.getColor)(background, theme));
};

var makeFontStyles = function makeFontStyles(font, theme) {
  var _a, _b, _c;

  var _font = font.toUpperCase();

  var value = (_c = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.TYPOGRAPHY) === null || _a === void 0 ? void 0 : _a[_font]) === null || _b === void 0 ? void 0 : _b.FONT) !== null && _c !== void 0 ? _c : ui_symbols_1.TYPOGRAPHY[_font].FONT;
  return "font-family: ".concat(value, ", ").concat(ui_symbols_1.TYPOGRAPHY.FALLBACK_FONT, ";");
}; // Note: Text weights currently don’t need a guard, because their keys include
// all available weights.


function isValidDisplayWeight(weight) {
  var isValid = (weight in ui_symbols_1.TYPOGRAPHY.DISPLAY);

  if (!isValid) {
    console.warn("\"".concat(String(weight).toLowerCase(), "\" is not a valid option for Display font. Valid options are: ").concat(Object.keys(ui_symbols_1.TYPOGRAPHY.DISPLAY_FONT_WEIGHT).map(function (c) {
      return c.toLowerCase();
    }).join(', '), "."));
  }

  return isValid;
}

var makeWeightStyles = function makeWeightStyles(_a) {
  var _b, _c, _d, _e, _f, _g;

  var theme = _a.theme,
      weight = _a.weight,
      font = _a.font;

  if (weight) {
    var _weight = weight.toUpperCase();

    if (font === 'text') {
      var value = (_d = (_c = (_b = theme === null || theme === void 0 ? void 0 : theme.TYPOGRAPHY) === null || _b === void 0 ? void 0 : _b.TEXT) === null || _c === void 0 ? void 0 : _c[_weight]) !== null && _d !== void 0 ? _d : ui_symbols_1.TYPOGRAPHY.TEXT[_weight];
      return "font-weight: ".concat(value);
    }

    if (font === 'display' && isValidDisplayWeight(_weight)) {
      var value = (_g = (_f = (_e = theme === null || theme === void 0 ? void 0 : theme.TYPOGRAPHY) === null || _e === void 0 ? void 0 : _e.DISPLAY) === null || _f === void 0 ? void 0 : _f[_weight]) !== null && _g !== void 0 ? _g : ui_symbols_1.TYPOGRAPHY.DISPLAY[_weight];
      return "font-weight: ".concat(value, ";");
    }
  }

  return "";
}; // Scale =======================================================================


var makeScaleStyles = function makeScaleStyles(scale, theme) {
  var _a;

  var _b = (0, ui_symbols_1.getFontScale)(scale, (_a = theme === null || theme === void 0 ? void 0 : theme.TYPOGRAPHY) === null || _a === void 0 ? void 0 : _a.SCALE),
      size = _b.size,
      lineHeight = _b.lineHeight;

  return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    font-size: ", ";\n    line-height: ", ";\n  "], ["\n    font-size: ", ";\n    line-height: ", ";\n  "])), size, lineHeight);
};

function toCSSValue(linkStyle) {
  if (linkStyle === 'underlined') {
    return 'underline';
  }

  return linkStyle;
} // Root =======================================================================


exports.Root = styled_components_1.default.span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['scale', 'font', 'pattern', 'color', 'weight', 'align', 'linkStyle', 'isInverse', 'isDisabled'].includes(prop);
  }
})(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  font-style: normal;\n  font-weight: inherit;\n  text-decoration: none;\n  border: none;\n  ", ";\n  ", ";\n  ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", ";\n  a {\n    ", ";\n  }\n"], ["\n  margin: 0;\n  padding: 0;\n  font-style: normal;\n  font-weight: inherit;\n  text-decoration: none;\n  border: none;\n  ", ";\n  ", ";\n  ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", ";\n  a {\n    ", ";\n  }\n"])), function (_a) {
  var align = _a.align;
  return align && "text-align: ".concat(align);
}, function (_a) {
  var theme = _a.theme;
  return makeScaleStyles(5, theme);
}, function (_a) {
  var theme = _a.theme;
  return makeFontStyles('text', theme);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.mapStyles)(props, 'pattern', ui_blocks_1.TYPOGRAPHY);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'font', makeFontStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'scale', makeScaleStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'color', makeColorStyles);
}, makeWeightStyles, function (_a) {
  var linkStyle = _a.linkStyle;
  return linkStyle && "text-decoration: ".concat(toCSSValue(linkStyle));
});
var templateObject_1, templateObject_2, templateObject_3;